import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APIService } from '../api/api.service'
import { AppearanceService } from '../appearance/appearance.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { Constants } from '../../constants/constants';
import { ClientService } from '../client/client.service';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationService 
{


  constructor(private apiService: APIService, private appearanceService: AppearanceService,
    private localStorageService: LocalStorageService, private clientService: ClientService) 
  {
    this.initService();
  }


  initService()
  {
    this.apiService.baseUrl = Constants.PROD_URL;

    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

      this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {
    
  }


  public getLocationDetails(uid): any 
  { 
    var payload = {
      locationUid: uid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid()
    }

    return this.apiService.getLocationDetails(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public exportMultipleLocationsDetailsToExcel(payload): any 
  { 
    return this.apiService.exportMultipleLocationsDetailsToExcel(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public exportLocationDetailsToExcel(payload): any 
  { 
    return this.apiService.exportLocationDetailsToExcel(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteLocationFile(payload): any 
  { 
    return this.apiService.deleteLocationFile(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public downloadLocationFile(data): any 
  { 
    return this.apiService.downloadLocationFile(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public exportMasterRoadlist(data): any 
  { 
    return this.apiService.exportMasterRoadlist(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateLocationDetails(location): any 
  { 
    return this.apiService.updateLocationDetails(location).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public addLocationHistoryLog(payload): any 
  { 
    return this.apiService.addLocationHistoryLog(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteLocation(locationUid): any 
  { 
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      locationUid: locationUid
    }
    return this.apiService.deleteLocation(payload).pipe(map((response: any) => {

      if (response.Success)
      {

      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }
}
